function mergeReducer(accumulated: string, currentValue?: string): string {
  if (!currentValue) {
    return accumulated;
  }
  if (accumulated) {
    return `${accumulated}-${currentValue}`;
  }
  return currentValue;
}

export const mergeTests = (...args: Array<string | undefined>) => {
  return args.reduce(mergeReducer, '');
};
